import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { Utilities } from '../models/utilities.model';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private dialogs = new Subject<AlertDialog>();
  private _isLoading = false;

  constructor(private toastyService: ToastrService) { }

  showDialog(message: string)
  showDialog(message: string, type: DialogType, okCallback: (val?: any) => any)
  showDialog(message: string, type: DialogType, okCallback?: (val?: any) => any, cancelCallback?: () => any, okLabel?: string, cancelLabel?: string, defaultValue?: string)
  showDialog(message: string, type?: DialogType, okCallback?: (val?: any) => any, cancelCallback?: () => any, okLabel?: string, cancelLabel?: string, defaultValue?: string) {

    if (!type)
      type = DialogType.alert;

    this.dialogs.next({ message: message, type: type, okCallback: okCallback, cancelCallback: cancelCallback, okLabel: okLabel, cancelLabel: cancelLabel, defaultValue: defaultValue });
  }

  showMessage(summary: string)
  showMessage(summary: string, detail: string, severity: MessageSeverity)
  showMessage(summaryAndDetails: string[], summaryAndDetailsSeparator: string, severity: MessageSeverity)
  showMessage(response: Response, ignoreValue_useNull: string, severity: MessageSeverity)
  showMessage(data: any, separatorOrDetail?: string, severity?: MessageSeverity) {
    if (!severity)
      severity = MessageSeverity.default;

    if (data instanceof Response) {
      data = Utilities.getHttpResponseMessage(data);
      separatorOrDetail = Utilities.captionAndMessageSeparator;
    }

    if (data instanceof Array) {
      for (let message of data) {
        let msgObject = Utilities.splitInTwo(message, separatorOrDetail);

        this.showMessageHelper(msgObject.firstPart, msgObject.secondPart, severity, false);
      }
    }
    else {
      this.showMessageHelper(data, separatorOrDetail, severity, false);
    }
  }

  showStickyMessage(summary: string): ActiveToast<any>
  showStickyMessage(summary: string, detail: string, severity: MessageSeverity, error?: any): ActiveToast<any>
  showStickyMessage(summaryAndDetails: string[], summaryAndDetailsSeparator: string, severity: MessageSeverity): ActiveToast<any>
  showStickyMessage(response: Response, ignoreValue_useNull: string, severity: MessageSeverity): ActiveToast<any>
  showStickyMessage(data: string | string[] | Response, separatorOrDetail?: string, severity?: MessageSeverity, error?: any): ActiveToast<any> {

    if (!severity)
      severity = MessageSeverity.default;

    if (data instanceof Response) {
      data = Utilities.getHttpResponseMessage(data);
      separatorOrDetail = Utilities.captionAndMessageSeparator;
    }


    if (data instanceof Array) {
      for (let message of data) {
        let msgObject = Utilities.splitInTwo(message, separatorOrDetail);

        return this.showMessageHelper(msgObject.firstPart, msgObject.secondPart, severity, true);
      }
    }
    else {

      if (error) {

        let msg = `Severity: "${MessageSeverity[severity]}", Summary: "${data}", Detail: "${separatorOrDetail}", Error: "${Utilities.safeStringify(error)}"`;

        switch (severity) {
          case MessageSeverity.default:
            this.logInfo(msg);
            break;
          case MessageSeverity.info:
            this.logInfo(msg);
            break;
          case MessageSeverity.success:
            this.logMessage(msg);
            break;
          case MessageSeverity.error:
            this.logError(msg);
            break;
          case MessageSeverity.warn:
            this.logWarning(msg);
            break;
          case MessageSeverity.wait:
            this.logTrace(msg);
            break;
        }
      }

      return this.showMessageHelper(data, separatorOrDetail, severity, true);
    }
    return null;
  }

  private showMessageHelper(summary: string, detail: string, severity: MessageSeverity, isSticky: boolean): ActiveToast<any> {
    return this.showToast({ severity: severity, summary: summary, detail: detail }, isSticky);
  }

  public closeAllToasts() {
    for (let toast of this.toastyService.toasts) {
      toast.toastRef.close();
    }
  }

  private loadingToast: ActiveToast<any> = null;
  startLoadingMessage(message = "Loading...", caption = "") {
    this._isLoading = true;
    this.loadingToast = this.showStickyMessage(caption, message, MessageSeverity.wait);
  }

  stopLoadingMessage() {
    this._isLoading = false;

    if (this.loadingToast) {
      this.loadingToast.toastRef.close();
    }
    this.loadingToast = null;
  }

  logDebug(msg) {
    console.debug(msg);
  }

  logError(msg) {
    console.error(msg);
  }

  logInfo(msg) {
    console.info(msg);
  }

  logMessage(msg) {
    console.log(msg);
  }

  logTrace(msg) {
    console.trace(msg);
  }

  logWarning(msg) {
    console.warn(msg);
  }

  get isLoadingInProgress(): boolean {
    return this._isLoading;
  }

  private showToast(message: AlertMessage, isSticky: boolean): ActiveToast<any> {

    if (message == null) {
      return;
    }
    var toast: ActiveToast<any>;
    switch (message.severity) {
      case MessageSeverity.default: toast = this.toastyService.info(message.detail, message.summary); break
      case MessageSeverity.info: toast = this.toastyService.info(message.detail, message.summary); break;
      case MessageSeverity.success: toast = this.toastyService.success(message.detail, message.summary); break;
      case MessageSeverity.error: toast = this.toastyService.error(message.detail, message.summary); break
      case MessageSeverity.warn: toast = this.toastyService.warning(message.detail, message.summary); break;
      case MessageSeverity.wait: toast = this.toastyService.info(message.detail, message.summary); break;
    }

    return toast;
  }
}

//******************** Dialog ********************//
export class AlertDialog {
  constructor(public message: string, public type: DialogType, public okCallback: (val?: any) => any, public cancelCallback: () => any,
    public defaultValue: string, public okLabel: string, public cancelLabel: string) {

  }
}

export enum DialogType {
  alert,
  confirm,
  prompt
}
//******************** End ********************//






//******************** Growls ********************//
export class AlertMessage {
  constructor(public severity: MessageSeverity, public summary: string, public detail: string) { }
}

export enum MessageSeverity {
  default,
  info,
  success,
  error,
  warn,
  wait
}
//******************** End ********************//
